import * as _ from "lodash";
import * as React from "react";
import { HashMap } from "../../../shared/model/HashMap";
import { IValueLabel } from "../../model/ITriggerData";
import { TypedDropdownInput } from "../TypedDropdownInput";
import { InputMode } from "./TriggerInput";
import { TypedTriggerInput } from "./TypedTriggerInput";

const TriggerInput = TypedTriggerInput as new () => TypedTriggerInput<HttpTriggerConfig>;

const BaseTriggerInput = TypedTriggerInput as new () => TypedTriggerInput<BaseHttpTriggerConfig>;
const DropdownInput = TypedDropdownInput as new () => TypedDropdownInput<BaseHttpTriggerConfig>;

export const HttpTrigger: React.FunctionComponent<HttpTriggerProps> = (props) => {
    return (<div>
        <HttpTriggerBase
            id={props.id}
            disableInputsFromSwagger={false}
            existingParameters={props.existingParameters}
            authOptions={AuthOptions.concat(HttpTriggerAuthOptions)}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="isPublic"
            label={FRENDS.Localizations.PublicHttpTriggerLabel}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
        <TriggerInput
            parameters={props.existingParameters}
            parameterName="passRawContentBytes"
            label={FRENDS.Localizations.HttpPassRawContentBytes}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
    </div>);
};

export const HttpTriggerBase: React.FunctionComponent<BaseHttpTriggerProps> = (props) => {

    function isCorsDisabled(): boolean {
        return !_.get(props.existingParameters, "corsEnabled");
    }

    return (<div>
        <DropdownInput
            disabled={props.disableInputsFromSwagger}
            options={HttpMethodOptions}
            elementId={props.id}
            parameters={props.existingParameters}
            parameterName="httpMethod"
            label={FRENDS.Localizations.HttpMethod}
        />
        <BaseTriggerInput
            disabled={props.disableInputsFromSwagger}
            parameters={props.existingParameters}
            parameterName="routeTemplate"
            label="URL"
            inputMode={InputMode.text}
            elementId={props.id}
        />
        <DropdownInput
            options={AllowedSchemas}
            elementId={props.id}
            parameters={props.existingParameters}
            parameterName="allowedSchemes"
            label={FRENDS.Localizations.AllowedSchemes}
        />
        <DropdownInput
            disabled={props.disableInputsFromSwagger}
            options={props.authOptions}
            elementId={props.id}
            parameters={props.existingParameters}
            parameterName="auth"
            label={FRENDS.Localizations.Authorization}
        />
        <BaseTriggerInput
            parameters={props.existingParameters}
            parameterName="corsEnabled"
            label={FRENDS.Localizations.CorsAllowedOrigins}
            description={FRENDS.Localizations.CorsAllowedOriginsExplained}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
        <BaseTriggerInput
            parameters={props.existingParameters}
            parameterName="allowedOrigins"
            inputMode={InputMode.text}
            disabled={isCorsDisabled()}
            elementId={props.id}
        />
    </div>);
};

export interface HttpTriggerProps {
    id: string;
    existingParameters: HttpTriggerConfig;
}

export interface HttpTriggerConfig extends BaseHttpTriggerConfig {
    isPublic: boolean;
    passRawContentBytes: boolean;
}

export interface BaseHttpTriggerProps {
    id: string;
    disableInputsFromSwagger: boolean;
    authOptions: IValueLabel[];
    existingParameters: BaseHttpTriggerConfig;
}

export interface BaseHttpTriggerConfig {
    routeTemplate: string;
    allowedSchemes: string;
    auth: HttpAuthorizationType;
    corsEnabled: boolean;
    allowedOrigins: string;
    httpMethod: HttpMethod;
}

export enum HttpMethod {
    ANY = "ANY",
    GET = "GET",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    HEAD = "HEAD",
    OPTIONS = "OPTIONS",
    PATCH = "PATCH"
}

export const HttpMethodOptions: IValueLabel[] =
    Object.keys(HttpMethod)
        .map((k) => ({ value: k, label: (HttpMethod as unknown as HashMap<HttpMethod>)[k] }));

export const AllowedSchemas: IValueLabel[] = [
    { value: "HTTPS", label: "HTTPS" },
    { value: "HTTP", label: "HTTP" },
    { value: "HTTP,HTTPS", label: "HTTP,HTTPS" }
];

export enum HttpAuthorizationType {
    Basic = "Basic",
    Certificate = "Certificate",
    ApiPolicy = "ApiPolicy"
}

export const AuthOptions: IValueLabel[] = [
    { value: HttpAuthorizationType.Basic, label: "Basic" },
    { value: HttpAuthorizationType.ApiPolicy, label: "API Policy" }
];

export const HttpTriggerAuthOptions: IValueLabel[] = [
    { value: HttpAuthorizationType.Certificate, label: "Certificate" },
];
